import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {
  sendEmailRecover as sendEmailRecoverApi
} from "../../../../api/clients/certificates";
import { Link } from "react-router-dom";
import { NOTIFICATION_CERTIFICATE_ACTIONS } from '../../../../config/notifications';
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function SendEmailRecover(props) {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const { index, actionCallback, certificate, showIcon } = props;

  const sendEmailRecover = () => {
    sendEmailRecoverApi({
      certificateId: certificate.uuid,
      notificationId: NOTIFICATION_CERTIFICATE_ACTIONS
    }).then((response) => {
      setShowConfirmationModal(false);

      if (response && response.status === 200) {
        actionCallback();
      }
    });
  };

  const shouldDisplay = (certificate) => {
    return (!certificate || !certificate.recover_vailable) ? false : true;
  }

  if (!shouldDisplay(certificate)) {
    return null;
  }

  return (<Fragment>
    {!showIcon ?
      <Fragment>
        <Button
          color="primary"
          size="sm"
          className="btn-warning"
          type="button"
          id={`recover-icon-${index}`}
          onClick={() => {
            store.dispatch(hideNotification());
            setShowConfirmationModal(true)
          }}
        >
          <FormattedMessage
            id="components.pages.management.manageCertificates.actionButtons.send_email_recover" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target={`recover-icon-${index}`}
          modifiers={{
            preventOverflow: {
              enabled: true,
              boundariesElement: "body",
            },
          }}
        >
          <FormattedMessage
            id="components.pages.management.manageCertificates.actionButtons.send_email_recover" />
        </UncontrolledTooltip>
      </Fragment> :
      <Fragment>
        <Link
          to="#"
          className="cursor-pointer px-2 mx-2 link-icon-color"
          id={`recover-icon-` + props.index}
          onClick={() => setShowConfirmationModal(true)}
        >
          <FontAwesomeIcon
            size="lg"
            className="cursor-pointer"
            pointerEvents="none"
            icon={faEnvelope}
          />
        </Link>
        <UncontrolledTooltip
          delay={0}
          target={`recover-icon-${props.index}`}
          modifiers={
            {
              preventOverflow: {
                enabled: true,
                boundariesElement: 'body'
              }
            }
          }
        >
          <FormattedMessage
            id="components.pages.management.manageCertificates.actionButtons.send_email_recover" />
        </UncontrolledTooltip>
      </Fragment>
    }

    <ConfirmationModal
      showModal={showConfirmationModal}
      closeModal={() => setShowConfirmationModal(false)}
      confirmationYes={sendEmailRecover}
      messageId="components.layout.confirmation.body.send_certificate_email_recover"
    />
  </Fragment>
  );
}

export { SendEmailRecover };
